<template>
  <v-container
    id="itemsList"
    fluid
    tag="section"
    class="full-height"
  >
    <base-v-component
      heading="Артикули"
    />

    <v-row class="mt-10 d-print-none">
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary px-5"
          @click="openImportModal"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Импортиране
        </v-btn>
      </v-col>
    </v-row>
    
    <filter-items
      ref="itemsFilter"
      @doFilter="getData"
    />

    <base-material-card
      hover-reveal
      color="primary"
      icon="mdi-book-open-page-variant"
      inline
      class="px-5 py-5 mt-15"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light"></div>
      </template>

      <v-divider class="mt-3 mb-6" />
      
      <base-data-table 
        :headers="table.headers" 
        :pagination="table.pagination" 
        :data="table.data" 
        :sortBy.sync="table.sortBy"
        :sortDesc.sync="table.sortDesc" 
        @getData="getData" 
        @doAction="doAction"
      />
    </base-material-card>
    <import-file-modal ref="importFileModal" @uploadFile="uploadFile" />
    <locate-tag-modal ref="locateTagModal" />
    <confirm-modal ref="confirmModal" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { filterItems, importFileModal, locateTagModal, confirmModal } from "@/components";
import { deleteItem, getItems, importItems, writeItemEPC } from '@/api/items';

export default {
  name: 'inventoriesList',
  components: {
    filterItems,
    importFileModal,
    locateTagModal,
    confirmModal
  },
  data: () => ({
    deleteItemId: '',
    table: {
      headers: [],
      data: [],
      pagination: {
        itemsPerPage: 10,
        page: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0
      },
      sortBy: 'date',
      sortDesc: true,
    }
  }),
  computed: {
    ...mapGetters([
      'zebraIsConnected',
      'isAdminUser'
    ])
  },
  mounted(){
    this.getData();
  },
  watch: {
    zebraIsConnected(){
      this.$forceUpdate;
      this.getData();
    }
  },
  methods: {
    getData(){
      this.table.headers = [
        { text: 'Дата', value: 'date', valueType: "date" },
        { text: 'Наименование', value: 'name', valueType: "text" },
        { text: 'Автор', value: 'author', valueType: "text" },
        { text: 'Инв. №', value: 'inventoryNumber', valueType: "text" },
        { text: 'Сигнатура', value: 'signature', valueType: "text" },
        { text: 'Година', value: 'publishedYear', valueType: "text" },
        { text: 'RFID запис', align: 'center', value: 'isWritten', valueType: "status", active: 1, notActive: 0, statusIcons: true, activeClass: 'fw600 success--text text-center', notActiveClass: 'fw600 error--text text-center' },
        {
          sortable: false,
          text: '',
          value: '',
          valueType: 'button',
          style: this.zebraIsConnected ? (this.isAdminUser ? 'width: 273px' : "width: 218px;") : (this.isAdminUser ? "width: 223px;" : 'width: 170px;'),
          class: 'text-right px-0 pr-2',
          buttons: [
            {
              show: this.zebraIsConnected,
              label: '',
              title: 'Намери артикула',
              icon: 'mdi-nfc-search-variant',
              size: 'small',
              class: 'secondary',
              click: 'locateEPCTag' 
            },
            {
              label: '',
              title: 'Запис RFID',
              icon: 'mdi-cellphone-nfc',
              size: 'small',
              class: 'secondary ml-1',
              click: 'writeItemEPC',
            },
            {
              label: 'Преглед',
              title: 'Преглед',
              icon: 'mdi-text-box-search-outline',
              size: 'small',
              class: 'primary ml-1',
              click: 'previewItem',
            },
            {
              show: this.isAdminUser,
              label: '',
              title: 'Изтрий',
              icon: 'mdi-trash-can-outline',
              size: 'small',
              class: 'error ml-1',
              click: 'deleteItem',
            }
          ]
        },
      ]

      let query = Object.assign({}, this.$refs.itemsFilter.filters);
      if(!query.page) query.page = this.table.pagination.page;
      query.itemsPerPage = this.table.pagination.itemsPerPage;
      query.sortBy = this.table.sortBy;
      query.sortDesc = this.table.sortDesc;
      getItems(query).then(data => {
        this.table.data = data.Items;
        this.table.pagination.total = data.Total;
        this.table.pagination.page = query.page;
      })
    },
    openImportModal(){
      this.$refs.importFileModal.openModal();
    },
    writeItemEPC(id){
      writeItemEPC({itemId: id}).then(() => {
        this.getData();
      })
    },
    confirmDeleteItem(id){
      if(this.isAdminUser){
        this.deleteItemId = id;
        let data = {
          title: 'Изтриване на артикул',
          body: 'Сигурни ли сте, че искате да изтриете избрания артикул?',
          callback: this.deleteItem
        }
        this.$refs.confirmModal.openModal(data);
      }
    },
    deleteItem(){
      if(this.deleteItemId && this.deleteItemId.length === 24 && this.isAdminUser){
        deleteItem({itemId: this.deleteItemId}).then(response => {
          if(response){
            this.getData();
            this.deleteItemId = '';
            this.$refs.confirmModal.open = false;
          }
        })
      }
    },
    locateTag(data){
      this.$refs.locateTagModal.openModal(data);
    },
    uploadFile(data){
      if(data.excelFile){
        let formData = new FormData();
        formData.append('file', data.excelFile);
        importItems(formData).then(() => {
          this.getData();
          this.$refs.importFileModal.closeModal()
        })
      }
    },
    doAction(actionData) {
      switch(actionData.action){
        case 'previewItem':
          this.$router.push({path: `/items/${actionData.item._id}`})
        break;
        case 'writeItemEPC':
          this.writeItemEPC(actionData.item._id)
        break;
        case 'locateEPCTag':
          this.locateTag(actionData.item);
        break;
        case 'deleteItem':
          this.confirmDeleteItem(actionData.item._id)
        break;
      }
    }
  }
}
</script>
